import { render, staticRenderFns } from "./ParticipantManager.vue?vue&type=template&id=38b1bdb2&scoped=true&"
import script from "./ParticipantManager.vue?vue&type=script&lang=js&"
export * from "./ParticipantManager.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantManager.vue?vue&type=style&index=0&id=38b1bdb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1bdb2",
  null
  
)

export default component.exports